













import { Component, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  name: 'HsNoData',
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  @Prop({ default: '검색결과가 없습니다.' }) title: string
  @Prop({ default: false }) borderless: boolean
}
